import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const ArchiveTicketValidationSchema = z.object({
  spaceId: z.string({ message: 'Space ID is required' }).min(1),
  ticketId: z.string({ message: 'Ticket ID is required' }).min(1),
});
export type TArchiveTicketValidation = z.infer<typeof ArchiveTicketValidationSchema>;
export type TArchiveTicketPayload = TArchiveTicketValidation;
export type TArchiveTicketResponse = ApiResponse<{
  message: string;
}>;

export const archiveTicket = async (payload: TArchiveTicketPayload): Promise<TArchiveTicketResponse> => {
  const url = `/ticket/archive-ticket/${payload.ticketId}`;

  return axiosInstance.patch(url);
};

/**
 * Use Archive Ticket React-Query Hook
 */
type UseArchiveTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof archiveTicket, AxiosErrorCustom>;
};

/**
 * Use Archive Ticket React-Query Hook
 */
export const useArchiveTicketMutation = ({ mutationConfig }: UseArchiveTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: archiveTicket,
    ...restConfig,
  });
};
